import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import "./Cookies.css"

class Cookies extends Component {
  render() {
    const { t } = this.props
    return (
      <div className="hp-cookies-wrap">
        <div role="button" tabIndex="0" className="dialog-close-button" onClick={() => this.props.dismissCookieWarning()}>
          <div className="dialog-close-line line-1" />
          <div className="dialog-close-line line-2" />
        </div>
        <div className="hp-cookies-inner-wrap">
          <p>{t(`cookies:text`)}</p>
          <p>
            <span>{t(`cookies:see`)}</span>
            <a href="/privacy" target="_blank" rel="noreferrer noopener">{t(`cookies:privacy`)}</a>
            <span>{t(`cookies:and`)}</span>
            <a href="/ad-and-cookie" target="_blank" rel="noreferrer noopener">{t(`cookies:ad`)}</a>
            <span>{t(`cookies:details`)}</span>
          </p>
        </div>
      </div>
    )
  }
}
export default withTranslation(['cookies'])(Cookies)
